import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "new window" }, [
  /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 5551" }, [
    /*#__PURE__*/_createElementVNode("path", {
      "data-name": "Path 8398",
      d: "M14.041 18.541H3.56V8.06H8.8V6.75H3.56a1.31 1.31 0 0 0-1.31 1.31v10.481a1.31 1.31 0 0 0 1.31 1.31h10.481a1.31 1.31 0 0 0 1.31-1.31V13.3h-1.31z",
      transform: "translate(-2.25 -3.851)",
      style: {"fill":"#f59600"}
    }),
    /*#__PURE__*/_createElementVNode("path", {
      "data-name": "Path 8399",
      d: "M18.921 2.25H12.37v1.31h5.624L9.75 11.8l.927.926 8.244-8.244v5.624h1.31V2.25z",
      transform: "translate(-4.23 -2.25)",
      style: {"fill":"#f59600"}
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };